var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/js/index.tsx
import classNames from "classnames";
import React from "react";
import { Link } from "react-router";
function Clickable(_a) {
  var _b = _a, {
    className,
    to,
    onClick,
    linkType = "normal",
    disabled = false,
    submit = false
  } = _b, props = __objRest(_b, [
    "className",
    "to",
    "onClick",
    "linkType",
    "disabled",
    "submit"
  ]);
  if (to && !disabled) {
    if (linkType !== "normal") {
      return /* @__PURE__ */ React.createElement(
        "a",
        __spreadValues(__spreadValues({
          href: to,
          onClick,
          className
        }, linkType === "new-tab" ? {
          target: "_blank",
          referrerPolicy: "no-referrer"
        } : {}), props)
      );
    } else {
      return /* @__PURE__ */ React.createElement(
        Link,
        __spreadValues({
          to,
          onClick,
          className
        }, props)
      );
    }
  } else if (submit || onClick) {
    return /* @__PURE__ */ React.createElement(
      "button",
      __spreadValues({
        onClick,
        className: classNames(className, { disabled }),
        disabled,
        type: submit ? "submit" : "button"
      }, props)
    );
  } else {
    return /* @__PURE__ */ React.createElement(
      "div",
      __spreadValues({
        className: classNames(className, { disabled })
      }, props)
    );
  }
}
export {
  Clickable
};
